/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orgName: NonNullable<unknown> }} Partner_Org_Unfreeze_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Restore {orgName}?" |
*
* @param {Partner_Org_Unfreeze_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_unfreeze_confirm_title = /** @type {((inputs: Partner_Org_Unfreeze_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Unfreeze_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.orgName} entsperren?`)
	return /** @type {LocalizedString} */ (`Restore ${i?.orgName}?`)
});